/* eslint-disable @typescript-eslint/naming-convention */
export enum ArchivedVisibilityTypeEnum {
	ShowArchived = 'show',
	HideArchived = 'hide'
}
